// extracted by mini-css-extract-plugin
export var chevron = "_2l-2";
export var chevronCollapsed = "_2l-3";
export var collapsibleHeader = "_2l-1";
export var container = "_2l-0";